'use strict';

var keyboardAccessibility = require('./keyboardAccessibility');
var header = require('./header').collapsibleHeader;
var utils = require('../utils');
var _ = require('lodash');
var $htmlTag = $('html');
var $mainMenu = $('.main-menu');
var previousScrollPosition = 2; // setting this to 2 for workaround of weird initial pageYOffset when at the top of the page

const isScrollingDown = function () {
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    var goingDown = scrollPosition > previousScrollPosition && scrollPosition > 50;
    previousScrollPosition = scrollPosition;
    return goingDown;
};

var clearSelection = function (element) {
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $(element).closest('.dropdown').find('.dropdown-item a,.dropdown-item span').attr('tabindex', -1);
    $('.menu-group a.nav-link').attr('aria-hidden', 'false');
};

function toggleQuickLinks(isHide) {
    $('.navbar-footer')
        .toggleClass('d-none', isHide)
        .siblings()
        .find('> .navbar-divider')
        .toggleClass('d-none', isHide);
}

function collapseMegaMenu() {
    $mainMenu.removeClass('in');

    if (utils.isMobileViewport()) {
        $mainMenu.attr('aria-hidden', 'true').prop('inert', true);
    }

    $mainMenu.siblings().attr('aria-hidden', 'false');
    $('.navbar-toggler').show().focus();
    $('.navbar-header .close-button').addClass('d-none');
    $('body').removeClass('no-scroll');
    $htmlTag.removeClass('main-menu-open');
    $('header').siblings().attr('aria-hidden', 'false');
    toggleQuickLinks(false);
    $('.menu-group').attr('aria-expanded', 'false').removeClass('subnav-open');
    $('.dropdown').removeClass('show');
    $('.dropdown-sub-menu').removeClass('has-vertical-scroll');

    // Remove focus trap when closing menu
    $mainMenu.off('keydown.focusTrap');
    $('.navbar-header .close-button').off('keydown.focusTrap');
}

function getMenuFocusableElements() {
    var isInSubmenu = $('.menu-group').hasClass('subnav-open');
    var $closeButton = $('.navbar-header .close-button:visible');
    var $visibleFocusable;
    var $submenuItems;
    var $navLinks;
    var $footerLinks;

    if (isInSubmenu) {
        // Find the deepest open dropdown (the innermost .dropdown.show)
        // This is the one that doesn't contain any nested .dropdown.show
        var $allOpenDropdowns = $mainMenu.find('.dropdown.show');
        var $deepestDropdown = $allOpenDropdowns.filter(function () {
            return $(this).find('.dropdown.show').length === 0;
        });

        // If no deepest found, use the last open dropdown
        if (!$deepestDropdown.length) {
            $deepestDropdown = $allOpenDropdowns.last();
        }

        // Get only items from the deepest dropdown's immediate submenu
        var $deepestSubmenu = $deepestDropdown.children('.dropdown-sub-menu');

        // Find focusable items only within this specific submenu level
        $submenuItems = $deepestSubmenu.find('a, .main-category-collapse, span.dropdown-toggle, span.dropdown-like-link')
            .filter(':visible')
            .filter(function () {
                var $element = $(this);
                // Only include if tabindex is 0 (explicitly focusable)
                return $element.attr('tabindex') === '0';
            });

        // Include the close button at the beginning of the focus order
        if ($closeButton.length) {
            $visibleFocusable = $closeButton.add($submenuItems);
        } else {
            $visibleFocusable = $submenuItems;
        }
    } else {
        // When in main menu, include:
        // 1. Close button (first)
        // 2. Top-level nav links that are actual <a> elements
        // 3. Footer links (country selector, account links, etc.)
        $navLinks = $mainMenu.find('.menu-group > .navbar-nav > .nav-item > a.nav-link')
            .filter(':visible')
            .filter(function () {
                return $(this).is('a');
            });

        // Include footer links (country selector and other quick links)
        // These are inside .navbar-footer which contains .nav-list-footer
        $footerLinks = $mainMenu.find('.navbar-footer:visible a, .navbar-footer:visible button, .navbar-footer:visible [role="button"]')
            .filter(':visible')
            .filter(function () {
                // Only include elements that are not disabled and can receive focus
                var $el = $(this);
                return !$el.prop('disabled') && $el.attr('tabindex') !== '-1';
            });

        // Combine nav links and footer links
        $visibleFocusable = $navLinks.add($footerLinks);

        // Include the close button at the beginning
        if ($closeButton.length) {
            $visibleFocusable = $closeButton.add($visibleFocusable);
        }
    }

    return $visibleFocusable;
}

function setupMobileMenuFocusTrap() {
    // Remove any existing focus trap first
    $mainMenu.off('keydown.focusTrap');
    $('.navbar-header .close-button').off('keydown.focusTrap');

    // Handle focus trap for elements inside the menu
    $mainMenu.on('keydown.focusTrap', function (e) {
        if (e.key !== 'Tab') return;

        var $closeButton = $('.navbar-header .close-button:visible');
        var isInSubmenu = $('.menu-group').hasClass('subnav-open');
        var $firstElement;
        var $lastElement;

        if (isInSubmenu) {
            // For submenu, use the deepest dropdown's items
            var $visibleFocusable = getMenuFocusableElements();
            var $menuItems = $visibleFocusable.not('.close-button');
            if (!$menuItems.length) return;
            $firstElement = $menuItems.first();
            $lastElement = $menuItems.last();
        } else {
            // For main menu, explicitly find first nav link and last footer item
            $firstElement = $mainMenu.find('.navbar-nav > .nav-item > .nav-link')
                .filter(function () {
                    return $(this).is(':visible') && $(this).is('a');
                })
                .first();

            // Last element is the last footer item, or last nav link if no footer
            $lastElement = $mainMenu.find('.navbar-footer:visible a, .navbar-footer:visible button, .navbar-footer:visible [role="button"]')
                .filter(':visible')
                .last();

            if (!$lastElement.length) {
                $lastElement = $mainMenu.find('.navbar-nav > .nav-item > .nav-link')
                    .filter(function () {
                        return $(this).is(':visible') && $(this).is('a');
                    })
                    .last();
            }
        }

        if (!$firstElement.length) return;

        var firstMenuItem = $firstElement[0];
        var lastMenuItem = $lastElement.length ? $lastElement[0] : firstMenuItem;

        // Handle Shift+Tab on first menu item - move to close button
        if (e.shiftKey && document.activeElement === firstMenuItem) {
            e.preventDefault();
            if ($closeButton.length) {
                $closeButton[0].focus();
            } else {
                lastMenuItem.focus();
            }
        } else if (!e.shiftKey && document.activeElement === lastMenuItem) {
            // Handle Tab on last menu item - move to close button
            e.preventDefault();
            if ($closeButton.length) {
                $closeButton[0].focus();
            } else {
                firstMenuItem.focus();
            }
        }
    });

    // Handle focus trap for the close button (which is outside .main-menu)
    $('.navbar-header .close-button').on('keydown.focusTrap', function (e) {
        if (e.key !== 'Tab') return;
        if (!$mainMenu.hasClass('in')) return; // Only when menu is open

        var $visibleFocusable = getMenuFocusableElements();
        if (!$visibleFocusable.length) return;

        var isInSubmenu = $('.menu-group').hasClass('subnav-open');
        var $menuItems;
        var $firstNavLink;

        if (e.shiftKey) {
            // Shift+Tab on close button - wrap to last menu item
            e.preventDefault();
            $visibleFocusable.last()[0].focus();
        } else {
            // Tab on close button - move to first menu item
            e.preventDefault();

            if (isInSubmenu) {
                // In submenu: focus first item from the submenu (excluding close button)
                $menuItems = $visibleFocusable.not('.close-button');
                if ($menuItems.length) {
                    $menuItems.first()[0].focus();
                }
            } else {
                // In main menu: explicitly focus the first nav link (not footer items)
                // Use a broad selector and filter to ensure we find the nav links
                $firstNavLink = $mainMenu.find('.navbar-nav > .nav-item > .nav-link')
                    .filter(function () {
                        var $el = $(this);
                        // Must be visible and be an anchor element (not span)
                        return $el.is(':visible') && $el.is('a');
                    })
                    .first();

                if ($firstNavLink.length) {
                    $firstNavLink[0].focus();
                }
            }
        }
    });
}

function expandMegaMenu() {
    if ($('#SearchPanel').hasClass('show')) {
        $('#SearchPanel').collapse('hide');
    }

    if ($('.collapse-left').hasClass('show')) {
        $('.collapse-left').find('.close:first').click();
    }

    $mainMenu.addClass('in')
        .attr('aria-hidden', 'false')
        .prop('inert', false)
        .siblings()
        .attr('aria-hidden', 'true');
    $('.navbar-toggler').hide();
    $('.navbar-header .close-button').removeClass('d-none');
    $('body').addClass('no-scroll');
    $('header').siblings().attr('aria-hidden', 'true');

    if ($mainMenu.hasClass('in')) {
        $htmlTag.addClass('main-menu-open');
    } else {
        $htmlTag.removeClass('main-menu-open');
    }

    if (utils.isMobileViewport()) {
        // Initialize all submenu items as hidden from keyboard and screen readers
        $mainMenu.find('.dropdown-sub-menu a, .dropdown-sub-menu .main-category-collapse')
            .attr('tabindex', '-1')
            .attr('aria-hidden', 'true');

        // Remove tabindex from dropdown-sub-menu containers to prevent them from being focusable
        $mainMenu.find('.dropdown-sub-menu').attr('tabindex', '-1');

        // Handle span elements that act as dropdown toggles (from Page Designer)
        // These should NOT be focusable in mobile - only the actual links
        $mainMenu.find('span.dropdown-toggle, span.dropdown-like-link').attr('tabindex', '-1');
    }

    // Move focus to the first focusable element in the newly revealed content
    // This improves accessibility for keyboard and screen reader users
    var firstFocusableElement = $mainMenu.find('.menu-group .nav-link').first();
    if (firstFocusableElement.length) {
        firstFocusableElement.focus();
    } else {
        // Fallback to close button if no nav links found
        $('.navbar-header .close-button').focus();
    }

    if (utils.isMobileViewport()) {
        setupMobileMenuFocusTrap();
    }
}

function collapseSubMenu($element) {
    $('.dropdown-sub-menu').addClass('has-vertical-scroll');
    var $dropdown = $element.closest('.dropdown');

    // Update aria-expanded on the toggle element that opened this submenu
    var $toggle = $dropdown.children('.dropdown-toggle, [role="button"]');
    $toggle.attr('aria-expanded', 'false');

    // Update aria-hidden on the submenu panel
    var submenuId = $toggle.attr('aria-controls');
    if (submenuId) {
        $('#' + submenuId).attr('aria-hidden', 'true');
    }

    $dropdown.removeClass('show')
        .find('.dropdown-sub-menu').removeClass('has-vertical-scroll')
        .find('.dropdown-link')
        .attr('tabindex', -1);

    if ($element.closest('.dropdown-menu').length === 0) {
        toggleQuickLinks(false);
        $('.menu-group').attr('aria-expanded', 'false').removeClass('subnav-open');
    }

    if (utils.isMobileViewport()) {
        // Hide all submenu items from keyboard and screen readers
        $dropdown.find('.dropdown-sub-menu a')
            .attr('tabindex', '-1')
            .attr('aria-hidden', 'true');
        $dropdown.find('.dropdown-sub-menu .main-category-collapse')
            .attr('tabindex', '-1')
            .attr('aria-hidden', 'true');

        // Return focus to the element that opened this submenu
        var $opener = $dropdown.data('opener');
        if ($opener && $opener.length) {
            setTimeout(function () {
                $opener.focus();
                $dropdown.removeData('opener');
            }, 50);
        }
        // Update focus trap after submenu closes
        setTimeout(function () {
            setupMobileMenuFocusTrap();
        }, 100);
    }
}

function expandSubMenu($element) {
    $('.navbar-nav .nav-link').attr('aria-hidden', 'true');

    // Expand submenu
    $('.menu-group').attr('aria-expanded', 'true').addClass('subnav-open');
    $('.dropdown-sub-menu').removeClass('has-vertical-scroll');
    var $dropdown = $element.closest('.dropdown');
    $dropdown.addClass('show')
        .find('.dropdown-sub-menu').addClass('has-vertical-scroll');
    toggleQuickLinks(true);

    // Update aria-expanded on the toggle element
    $element.attr('aria-expanded', 'true');

    // Update aria-hidden on the submenu panel
    var submenuId = $element.attr('aria-controls');
    if (submenuId) {
        $('#' + submenuId).attr('aria-hidden', 'false');
    }

    if (utils.isMobileViewport()) {
        // Store the element that opened the submenu for later return focus
        $dropdown.data('opener', $element);

        // Get the immediate dropdown-sub-menu wrapper
        var $directSubmenuWrapper = $dropdown.children('.dropdown-sub-menu');
        var $directSubmenu = $directSubmenuWrapper.children('.dropdown-menu');

        // Ensure the dropdown-sub-menu wrapper itself is NOT focusable
        $directSubmenuWrapper.attr('tabindex', '-1');

        // Set tabindex="0" and aria-hidden="false" on the back button
        $directSubmenuWrapper.children('.main-category-collapse')
            .attr('tabindex', '0')
            .attr('aria-hidden', 'false');

        // Handle the "All X" link which is in dropdown-item-all-wrapper
        $directSubmenu.children('.dropdown-item-all-wrapper').find('a')
            .attr('tabindex', '0')
            .attr('aria-hidden', 'false');

        // Handle items in the equal-columns structure (LEVEL 2: Footwear, Accessories, Men, Women, etc.)
        var $columnItems = $directSubmenu.children('.equal-columns-container')
            .find('.equal-columns > [class*="experience-column"] > .dropdown-item');
        $columnItems.each(function () {
            var $item = $(this);

            // Find the direct child link or span toggle
            var $directLink = $item.find('> a');
            var $directSpan = $item.find('> span.dropdown-toggle, > span.dropdown-like-link');

            // Make actual links focusable
            if ($directLink.length) {
                $directLink.attr('tabindex', '0').attr('aria-hidden', 'false');
            }

            // Make span toggles focusable if they are dropdown toggles (like "Featured" category)
            // These need to be focusable so users can expand the submenu via keyboard
            if ($directSpan.length && $item.hasClass('dropdown')) {
                $directSpan.attr('tabindex', '0').attr('aria-hidden', 'false');
            }

            // If this item has a nested dropdown, keep ALL its nested items at tabindex="-1" and aria-hidden="true"
            if ($item.hasClass('dropdown')) {
                $item.find('.dropdown-sub-menu').attr('tabindex', '-1');
                $item.find('.dropdown-sub-menu a')
                    .attr('tabindex', '-1')
                    .attr('aria-hidden', 'true');
                $item.find('.dropdown-sub-menu .main-category-collapse')
                    .attr('tabindex', '-1')
                    .attr('aria-hidden', 'true');
            }
        });

        // Handle items in the experience-items structure (LEVEL 3: Golf Shoes, G/18, Polos, etc.)
        var $itemsList = $directSubmenu.children('li').children('.experience-items');
        if ($itemsList.length > 0) {
            $itemsList.children('.dropdown-item').each(function () {
                $(this).find('> a')
                    .attr('tabindex', '0')
                    .attr('aria-hidden', 'false');
            });
        }

        // Set focus to first visible menu item (not the Back button, start with first actual menu item)
        setTimeout(function () {
            // Find the first focusable link in the submenu (ignoring the back button)
            // Priority: 1. "All X" link, 2. First item in the list
            var $firstFocusable = $directSubmenu.find('a[tabindex="0"]').first();
            if ($firstFocusable.length) {
                $firstFocusable.focus();
            }
            // Update focus trap after submenu opens
            setupMobileMenuFocusTrap();
        }, 50);
    }
}

function closeMenu($element) {
    if (!utils.isMobileViewport()) {
        $element.removeClass('show')
            .children('.dropdown-sub-menu')
            .children('.dropdown-menu').removeClass('show')
            .find('li a')
            .attr('tabindex', 0);
        $element.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
    }
}

function suppressExperienceItemsListCount() {
    $('.dropdown-menu[role="menu"]').find('ul.experience-items').each(function () {
        $(this).attr('role', 'none');
        $(this).children('li').attr('role', 'none');
    });
}

module.exports = function () {
    suppressExperienceItemsListCount();
    // On mobile, menu starts hidden (off-canvas); aria-hidden and inert are not needed on desktop
    if (utils.isMobileViewport()) {
        $mainMenu.attr('aria-hidden', 'true').prop('inert', true);
    }

    var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    // Prevent Enter key from navigating on top-level nav items with dropdowns (desktop only)
    // This handles keyboard Enter and screen reader virtual clicks
    var $topLevelNavLinks = $('.main-menu .nav-item > .nav-link, .main-menu .nav-item > .dropdown-toggle, .main-menu .nav-item > [role="button"]');
    var lastKeydownTime = 0;
    var lastMousedownTime = 0;
    var hadFocusBeforeMousedown = false;

    $topLevelNavLinks.on('keydown', function (e) {
        if (e.which === 13 && !utils.isMobileViewport()) {
            var $navItem = $(this).parent('.nav-item');
            // Only prevent if this nav item has a dropdown menu
            if ($navItem.find('.dropdown-menu').length > 0) {
                e.preventDefault();
                lastKeydownTime = Date.now();
            }
        }
    });

    // Track real mouse down events and whether element had focus before mousedown
    $topLevelNavLinks.on('mousedown', function () {
        // Check if THIS element already had focus before the mousedown
        // Real mouse clicks: element doesn't have focus yet
        // Screen reader/keyboard: element already has focus from Tab navigation
        hadFocusBeforeMousedown = (document.activeElement === this);
        lastMousedownTime = Date.now();
    });

    // Handle clicks from keyboard/screen reader (but not real mouse clicks)
    $topLevelNavLinks.on('click', function (e) {
        if (!utils.isMobileViewport()) {
            var $navItem = $(this).parent('.nav-item');
            // Only prevent if this nav item has a dropdown menu
            if ($navItem.find('.dropdown-menu').length > 0) {
                // Detect if this click is from keyboard/screen reader:
                // NVDA simulates complete mouse events including mousedown
                // Key insight: Check if element had focus BEFORE mousedown
                    // - Real mouse click: element gains focus ON mousedown → hadFocusBeforeMousedown = false
                    // - Screen reader: element already has focus from Tab → hadFocusBeforeMousedown = true
                var now = Date.now();
                var timeSinceKeydown = now - lastKeydownTime;
                var timeSinceMousedown = now - lastMousedownTime;
                var isKeyboardClick = timeSinceKeydown < 200;
                var isScreenReaderClick = e.clientX === 0 && e.clientY === 0;

                // Determine if this is a screen reader/keyboard click:
                // - Keyboard Enter within 200ms, OR
                // - Coordinates are 0,0 (some screen readers), OR
                // - Element had focus BEFORE mousedown (screen reader with Tab+Enter)
                if (isKeyboardClick || isScreenReaderClick || (hadFocusBeforeMousedown && timeSinceMousedown < 200)) {
                    // This is a keyboard/screen reader click - prevent navigation and toggle menu
                    e.preventDefault();
                    e.stopPropagation();

                    // Manually toggle the menu
                    var $link = $(this);
                    if ($navItem.hasClass('show')) {
                        // Close the menu
                        $navItem.removeClass('show');
                        $navItem.children('.dropdown-menu').removeClass('show');
                        $navItem.find('a').attr('tabindex', 0);
                        $link.attr('aria-expanded', 'false');
                    } else {
                        // Close other open menus
                        $('.navbar-nav .show').removeClass('show')
                            .children('.dropdown-menu').removeClass('show')
                            .parent()
                            .children('.nav-link, .dropdown-toggle, [role="button"]')
                            .attr('aria-expanded', 'false');

                        // Open this menu
                        $navItem.addClass('show');
                        $navItem.children('.dropdown-menu').addClass('show');
                        $navItem.find('a').attr('tabindex', 0);
                        $link.attr('aria-expanded', 'true');

                        // Focus on first item in dropdown after a short delay
                        setTimeout(function () {
                            $navItem.find('.dropdown-menu > li > a').first().focus();
                        }, 50);
                    }

                    return false;
                }
                // Real mouse clicks fall through and navigate normally
                return true;
            }
        }
        return true;
    });

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show')
                        .parent()
                        .children('.nav-link, .dropdown-toggle, [role="button"]')
                        .attr('aria-expanded', 'false');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'true');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    menuItem.find('.dropdown-menu > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.children('.dropdown-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    menuItem.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    menuItem.children('.dropdown-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'true');
                    menuItem.find('.dropdown-menu > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link, .dropdown-link, .dropdown-toggle, [role="button"]')
                        .attr('aria-expanded', 'false');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    menuItem.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                    menuItem.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    var $parentItem = menuItem.closest('.show');
                    $parentItem.removeClass('show')
                        .children('.dropdown-link, .dropdown-toggle, [role="button"]')
                        .attr('aria-expanded', 'false');
                    $parentItem.closest('li.show').removeClass('show')
                        .children('.nav-link, .dropdown-toggle, [role="button"]')
                        .attr('aria-expanded', 'false')
                        .first()
                        .focus();
                }
            },
            13: function (menuItem) { // enter
                // Only handle Enter key for top-level nav items with dropdowns on desktop
                if (menuItem.hasClass('nav-item') && !utils.isMobileViewport()) {
                    var $link = menuItem.children('.nav-link, .dropdown-toggle, [role="button"]').first();

                    if (menuItem.hasClass('show')) {
                        // Close the menu if it's already open
                        menuItem.removeClass('show');
                        menuItem.children('.dropdown-menu').removeClass('show');
                        menuItem.find('a').attr('tabindex', 0);
                        $link.attr('aria-expanded', 'false');
                    } else {
                        // Close other open menus
                        $('.navbar-nav .show').removeClass('show')
                            .children('.dropdown-menu').removeClass('show')
                            .parent()
                            .children('.nav-link, .dropdown-toggle, [role="button"]')
                            .attr('aria-expanded', 'false');

                        // Open this menu
                        menuItem.addClass('show');
                        menuItem.children('.dropdown-menu').addClass('show');
                        menuItem.find('a').attr('tabindex', 0);
                        $link.attr('aria-expanded', 'true');

                        // Focus on first item in dropdown
                        menuItem.find('.dropdown-menu > li > a').first().focus();
                    }

                    // Prevent navigation on Enter key
                    return false;
                }
                // For mobile or non-dropdown items, allow default behavior (navigation)
                return true;
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');

                // Close all child menus first
                parentMenu.find('.show').removeClass('show')
                    .children('.dropdown-menu').removeClass('show');
                parentMenu.find('.dropdown-link, .dropdown-toggle, [role="button"]')
                    .attr('aria-expanded', 'false');

                // Close the parent menu
                parentMenu.children('.dropdown-menu').removeClass('show');
                parentMenu.removeClass('show')
                    .children('.nav-link, .dropdown-toggle, [role="button"]')
                    .attr('aria-expanded', 'false');

                // Set tabindex for accessibility
                parentMenu.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);

                // Focus on the parent link
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    $('.dropdown:not(.disabled) .dropdown-toggle')
        .on('click', function (e) {
            if (utils.isMobileViewport()) {
                e.preventDefault();
                expandSubMenu($(this));
            }
        })
        .on('keydown', function (e) {
            if (utils.isMobileViewport() && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                expandSubMenu($(this));
            }
        })
        .on('mouseenter', function () {
            var $element = $('.nav-item.dropdown.show');
            if ($(this).hasClass('nav-link') && !$(this).parent('.nav-item').hasClass('show')) {
                closeMenu($element);
            }
        })
        .on('mouseenter', function () {
            if (!utils.isMobileViewport()) {
                var $element = $(this);
                $('.navbar-nav > li').each(function () {
                    if (!$.contains(this, $element)) {
                        $element.find('.show').each(function () {
                            clearSelection($element);
                        });
                        if ($element.hasClass('show')) {
                            $element.removeClass('show');
                            $element.children('.dropdown-menu').removeClass('show');
                            $element.children('.nav-link, .dropdown-toggle, [role="button"]').attr('aria-expanded', 'false');
                            $element.children('.dropdown-menu').find('.dropdown-item a').attr('tabindex', 0);
                        }
                    }
                });
                // need to close all the dropdowns that are not direct parent of current dropdown
                $element.parent().addClass('show');
                $element
                    .siblings('.dropdown-sub-menu').children('.dropdown-menu').addClass('show')
                    .find('.dropdown-item a')
                    .attr('tabindex', 0);
                $element.attr('aria-expanded', 'true');
            }
        })
        .closest('.navbar')
        .on('mouseleave', function () {
            var $element = $(this).find('.dropdown');
            closeMenu($element);
        });

    $('.nav-item:not(.dropdown) .nav-link').on('mouseenter', function () {
        var $element = $('.nav-item.dropdown.show');
        if ($element) {
            closeMenu($element);
        }
    });

    $('.navbar-header').on('click', '.close-button', function (e) {
        e.preventDefault();
        collapseMegaMenu();
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.main-category-collapse', function (e) {
        e.preventDefault();
        collapseSubMenu($(this));
    });

    $('.navbar-nav').on('keydown', '.main-category-collapse', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            collapseSubMenu($(this));
        }
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();

        var root = document.documentElement;
        var headerHeight = $('header').outerHeight();
        root.style.setProperty('--header-height', `${headerHeight}px`);

        expandMegaMenu();
    });

    keyboardAccessibility('.navbar-header .close-button',
        {
            9: function (navHeaderItem) {
                navHeaderItem.closest('.main-menu').find('.menu-group .nav-link').first();
            }
        },
        function () {
            return $(this);
        }
    );

    $('.menu-group .nav-link.first-link').on('keyup', function (e) {
        if (e.shiftKey && e.keyCode === 9) {
            $('.navbar-header .close-button').focus();
        }
    });

    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });

    const scrollThrottle = _.throttle(function () {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        var maxScrollTop = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        var isNearBottom = scrollPosition >= maxScrollTop - 2;

        if (isNearBottom) {
            previousScrollPosition = scrollPosition;
            return;
        }

        var isSD = isScrollingDown();
        var collapsed = header.isCollapsed();

        if (isSD && !collapsed) {
            // scrolling down and collapsible element aren't collapsed
            header.collapse();
        } else if (!isSD && collapsed) {
            // scrolling up and collapsible elements are still collapsed
            header.expand();
        }
    }, 100);

    $(window).on('scroll', scrollThrottle);

    utils.smartResize(function () {
        // Reset the attribute and class value for menus
        if ($('.subnav-open')[0] && !utils.isMobileViewport()) {
            $('.main-category-collapse').trigger('click');
            $('.navbar-header .close-button').trigger('click');
        }

        if (!$('.close-button.mega-menu-button.d-none')[0] && !utils.isMobileViewport()) {
            $('.navbar-header .close-button').trigger('click');
        }

        // Sync aria-hidden/inert based on viewport: only hidden on mobile when menu is closed
        if (utils.isMobileViewport()) {
            if (!$mainMenu.hasClass('in')) {
                $mainMenu.attr('aria-hidden', 'true').prop('inert', true);
            }
        } else {
            $mainMenu.removeAttr('aria-hidden').prop('inert', false);
        }
    });

    $('.search-toggler.collapsed .search-icon svg').on('click', function () {
        $htmlTag.removeClass('main-menu-open');
        if (!$('.close-button.mega-menu-button.d-none')[0] && utils.isMobileViewport()) {
            $('.navbar-header .close-button').trigger('click');
        }
    });

    $('.nav-link , .dropdown-link, footer a, .minicart a.minicart-link, .navbar-header .user,.navbar-header .user .user-dropdown-menu .dropdown-item a,.logo-home').click(function () {
        sessionStorage.removeItem('scrollPosition');
    });

    $(document).on('custom:collapse:mega:menu', collapseMegaMenu);
};
